module.exports = __webpack_public_path__ + "static/updatingData-47c9ffc7a85cbf36920a083a1062faea.gif";